import _ from 'lodash';
import config from '../../config'

let self = module.exports = {
  
  nullOrUndefined: function (obj){
    if (obj===undefined || obj===null){
      return true
    }
    else{
      return false
    }
  }, 

  parseStringParam: function (str, param) {
    if (!str || !str.includes("?")) {
      return null;
    }
    let split = str.split("?")[1].split("&");
    let match = null;
    _.forEach(split, (p) => {
      if (p.split("=")[0] === param) {
        match = p.split("=")[1];
        return;
      }
    });
    return match;
  },

  flexibleBool: function (entry) {
    if (typeof entry === 'string' || entry instanceof String) {
      entry = entry.toLowerCase();
    }
    if (entry === true || entry === "true") {
      return true;
    }
    if (entry === false || entry === "false") {
      return false;
    }
    return false;
  },

  shallowEqual: function (objA, objB) {
    if (objA === objB) {
      return true;
    }

    if (typeof objA !== 'object' || objA === null ||
      typeof objB !== 'object' || objB === null) {
      return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
      return false;
    }

    // Test for A's keys different from B.
    var bHasOwnProperty = hasOwnProperty.bind(objB);
    for (var i = 0; i < keysA.length; i++) {
      if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
        return false;
      }
    }

    return true;
  },

  //check for required data or reroute to the start if updated
  checkData: function (data, entry_point) {
    if (!data) {
      var loc = window.location.href
      var root = loc.substring(0, loc.lastIndexOf('/'));
      window.location = root + entry_point;
    }
  },

  dpath: function (mode, filepath, filename, webkey) {
    if (mode === "local") {
      return filepath + filename;
    }
    let stra = filepath.split(/[/]/);
    let data = {}
    for (var i = 0; i < stra.length; i++) {
      if (stra[i] === "companies") {
        data.company = stra[i + 1]
      }
      if (stra[i] === "projects") {
        data.project = stra[i + 1]
        data.folder = stra[i + 2]
      }
    }
    return config.WEB_SERVER + "/protectedfile/download?company=" + data.company + "&project=" + data.project + "&subdir=" + data.folder + "&file=" + filename + "&mode=" + mode + "&webkey=" + webkey
  },

  dp: function (screen, image, defaultImage, resProtected) {
    let isProtected = resProtected;
    if (isProtected === undefined) {
      isProtected = true;
    }

    let imageFinal = image;

    if (image === null || image === undefined) {
      isProtected = false;
      if (!defaultImage) {
        imageFinal = { path: '/img/ui/', file_name: 'empty.png' }
      }
      else { //blank image path
        imageFinal = defaultImage
      }
    }
    
    if (screen.mode === "local" || (isProtected === false && screen.mode !== "local")) {
      imageFinal = imageFinal.path + imageFinal.file_name;
      if (imageFinal.charAt(0) !== "/" && imageFinal.charAt(0) !== "\\") {
        return "/" + imageFinal
      }
      else {
        return imageFinal
      }
    }

    let stra = imageFinal.path.split(/[/]/);
    let data = {}
    for (var i = 0; i < stra.length; i++) {
      if (stra[i] === "companies") {
        data.company = stra[i + 1]
      }
      if (stra[i] === "projects") {
        data.project = stra[i + 1]
        data.folder = stra[i + 2]
      }
    }

    // If the resource is a video that has been converted, use that resource.
    let fileType = module.exports.getFileType(imageFinal.file_name);
    let fileName = imageFinal.file_name;
    if (imageFinal.conversion_status && imageFinal.conversion_status === "finished" && fileType === "video") {
      if (imageFinal.preview_video_name) {
        fileName = imageFinal.preview_video_name;
      }
    }

    return config.WEB_SERVER + "/protectedfile/download?company=" + data.company + "&project=" + data.project + "&subdir=" + data.folder + "&file=" + fileName + "&mode=" + screen.mode + "&webkey=" + screen.webkey
  },

  videoType: function (file_name) {
    if (!file_name) {
      return null;
    }
    let videoExt = file_name.split('.').pop();
    switch (videoExt) {
      case 'mov':
      case 'mp4':
        return "video/mp4";
      case 'webm':
        return "video/webm";
      case "ogg":
        return "video/ogg";
      default:
        return null;
    }
  },

  presetDp: function(name, image, screen) {
    const defaultImg = { path: '/img/ui/', file_name: 'image_default.png' }
    if (!image || !image.presets) {
      return self.dp(screen, image, defaultImg);
    } else {
      let thumbImg = _.find(image.presets, preset => {
        return preset.file_name.includes(name);
      });
      if (thumbImg) {
        return self.dp(screen, thumbImg, defaultImg);
      } else {
        return self.dp(screen, image, defaultImg);
      }
    }
  },

  // donorsIncluded: function (donorCategories, include_categories) {
  //     if (donorCategories.length === 0) {
  //         return [];
  //     }
  //     let donorsGrouped = [];
  //     _.forEach(donorCategories, (category) => {
  //         if (category.donors.length > 0) {
  //             _.forEach(include_categories, (icat) => {
  //                 if (icat === category.id) {
  //                     let pushGroup = { id: category.id, name: category.name, subheader: category.subheader, donors: category.donors, parent_category: category.parent_category, description: category.description };
  //                     donorsGrouped.push(pushGroup);
  //                 }
  //             });
  //         }
  //     });
  //     donorsGrouped = _.orderBy(donorsGrouped, 'rank', 'asc');
  //     return donorsGrouped
  // },

  randomRangeFloat: function (min, max) {
    if (max === undefined) {
      max = min;
      min = 0;
    }

    if (typeof min !== 'number' || typeof max !== 'number') {
      throw new TypeError('Expected all arguments to be numbers');
    }

    return Math.random() * (max - min) + min;
  },

  getRandomInt: function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },

  loopIndex: (currentIndex, min, max, direction) => {
    if (direction === "forward") {
      let result = currentIndex + 1;
      if (result > max) {
        return min;
      }
      return result;
    }
    else {
      let result = currentIndex - 1;
      if (result < min) {
        return max;
      }
      return result
    }
  },

  getFileType(str) {
    str = str.split('.');
    let lowercaseExt = str[str.length - 1].toLowerCase();
    let audioExtensions = ['mp3', 'wav', 'ogg', 'aac'];
    let imageExtensions = ['jpg', 'jpeg', 'png', 'tiff', 'svg', 'gif'];
    let videoExtensions = ['webm', 'mp4', 'mov'];

    if (audioExtensions.indexOf(lowercaseExt) > -1) {
      return "audio";
    }

    if (imageExtensions.indexOf(lowercaseExt) > -1) {
      return "image";
    }

    if (videoExtensions.indexOf(lowercaseExt) > -1) {
      return "video";
    }

    return "unsupported";
  },

  getUniqueFolderModules: (folderModules, donorCategories, stories, folderId) => {
    let donors = self.getAllDonors(donorCategories);
    let modules = _(folderModules)
    .filter((fm) => fm.folder === Number(folderId))
    .uniqBy(fm => [fm.module_id, fm.model].join())
    .map(fm => {
      let module = [];
      switch(fm.model) {
        case "story":
          module = _.find(stories, { id: fm.module_id });
        break;
        case "donor":
          module = _.find(donors, { id: fm.module_id });
        break;
        default:
        break
      }
      if (module) {
        module.rank = fm.rank;
        module.folder_module = fm;
      }
      return module;
    })
    .orderBy(['rank'], ['asc']).value();

    return _.compact(modules);
  },

  getAllFolderModules: (folderModules, donorCategories, stories, folderId) => {
    let donors = donorCategories ? self.getAllDonors(donorCategories) : [];
    let modules = _(folderModules)
    .filter((fm) => fm.folder === Number(folderId))
    .map(fm => {
      let module;
      switch(fm.model) {
        case "story":
          module = _.find(stories, { id: fm.module_id });
        break;
        case "donor":
          module = _.find(donors, { id: fm.module_id });
        break;
        default:
        break
      }
      return { ...module, rank: fm.rank, folder_module: fm }
    })
    .orderBy(['rank'], ['asc']).value();

    return modules;
  },

  getAllDonors: (donorCategories) => {
    let allDonors = [];
    for (let i = 0; i < donorCategories.donorCategories.length; i++) {
      if (donorCategories.donorCategories[i].donors.length > 0) {
        allDonors = allDonors.concat(donorCategories.donorCategories[i].donors);
      }
    }

    return allDonors;
  },



  createFolderTree: (folders, folderModules, parent, allStories, activeModules, mainMenuName, sortingField, direction) => {
    if (self.nullOrUndefined(parent)) {
      let mainName, main;
      if (typeof mainMenuName === "number") {
        main = _.find(folders, { id: mainMenuName });
      } else {
        mainName = self.nullOrUndefined(mainMenuName) ? "Main" : mainMenuName;
        main = _.find(folders, { name: mainName });
      }
      let children = self.createFolderTree(folders, folderModules, main, allStories, activeModules, mainMenuName, sortingField, direction);
      main.children = children;
      return main;
    } else {
      let children = folders.filter(fl => fl.parent_category === parent.id).sort((a, b) => {
        return a.rank - b.rank
      });
      if (children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          children[i].children = self.createFolderTree(folders, folderModules, children[i], allStories, activeModules, mainMenuName, sortingField, direction = "asc");
        }
        return children;
      } else {
        let modules = [];
        let folderFolderModules = _.filter(folderModules, { folder: parent.id });
        let stories = [];
        let foldersToPush = [];
        let displayModules = [];
        
        _.forEach(folderFolderModules, fm => {
          switch (fm.model) {
            case "display_module":
              let dm = _.find(activeModules, { id: fm.module_id });
              if (dm) {
                let dmToPush = _.cloneDeep(dm);
                dmToPush.node_type =  'display_module';
                dmToPush.folder_module_id = fm.id;
                dmToPush.rank = fm.rank;
                displayModules.push(dmToPush);
              }
            break;
            case "story":
            let story = _.find(allStories, { id: fm.module_id });
              if (story) {
                let storyToPush = _.cloneDeep(story);
                storyToPush.node_type =  'story';
                storyToPush.folder_module_id = fm.id;
                storyToPush.rank = fm.rank;
                stories.push(storyToPush);
              }
            break;

            case "folder":
              let folder = _.find(folders, { id: fm.module_id });
              if (folder) {
                let folderToPush = _.cloneDeep(folder);
                folderToPush.node_type =  'folder';
                folderToPush.folder_module_id = fm.id;
                folderToPush.rank = fm.rank;
                foldersToPush.push(folderToPush);
              }
            break;

            default:
            break;
          }
        });

        if (sortingField && sortingField !== "rank") {
          if (sortingField.includes(".")) {
            let arraySortingField = sortingField.split(".");
            let sortingFieldName = arraySortingField[arraySortingField.length - 1];
            stories = stories.map(st => {
              let value = _.get(st, sortingField, null);
              st[sortingFieldName] = value;
              return st;
            });

            stories = _.orderBy(stories, [sortingFieldName], [direction]);
          } else {
            stories = _.orderBy(stories, [sortingField], [direction]);
          }
        }

        if (stories.length > 0) {
          modules = modules.concat(stories);
        }

        if (displayModules.length > 0) {
          modules = modules.concat(displayModules);
        }

        if (foldersToPush.length > 0) {
          modules = modules.concat(foldersToPush);
        }

        if (sortingField && sortingField === "rank") {
          modules = modules.sort((a, b) => {
            if (direction === "asc") {
              return b.rank - a.rank;
            }
            return a.rank - b.rank;
          });
        }

        return modules;
      }
    }
  },

  createFolderTreeV2: (folders, folderModules, parent, allStories, activeModules, mainMenuName, sortingField) => {
    // console.log("calling");
    if (self.nullOrUndefined(parent)) {
      // console.log("here 1");
      let mainName = self.nullOrUndefined(mainMenuName) ? "Main" : mainMenuName;
      let main = _.find(folders, { name: mainName });
      let children = self.createFolderTree(folders, folderModules, main, allStories, activeModules, mainMenuName, sortingField);
      main.children = children;
      return main;
    } else {
      // console.log("here 2");
      let children = folders.filter(fl => fl.parent_category === parent.id).sort((a, b) => {
        return a.rank - b.rank
      });
      if (children.length > 0) {
        // console.log("here 3");
        for (let i = 0; i < children.length; i++) {
          children[i].children = self.createFolderTree(folders, folderModules, children[i], allStories, activeModules, mainMenuName, sortingField);
        }
        return children;
      } else {
        // console.log("here 4");
        let modules = [];
        let folderFolderModules = _.filter(folderModules, { folder: parent.id });
        folderFolderModules = _.orderBy(folderFolderModules, "rank", "desc");
        // console.log("folderFolderModules?", folderFolderModules)
        _.forEach(folderFolderModules, fm => {
          switch (fm.model) {
            case "display_module":
              let dm = _.find(activeModules, { id: fm.module_id });
              if (dm) {
                let dmToPush = _.cloneDeep(dm);
                dmToPush.node_type =  'display_module';
                dmToPush.folder_module_id = fm.id;
                modules.push(dmToPush);
              }
            break;
            case "story":
            let story = _.find(allStories, { id: fm.module_id });
              if (story) {
                let storyToPush = _.cloneDeep(story);
                storyToPush.node_type =  'story';
                storyToPush.folder_module_id = fm.id;
                modules.push(storyToPush);
              }
            break;

            case "folder":
              let folder = _.find(folders, { id: fm.module_id });
              if (folder) {
                let folderToPush = _.cloneDeep(folder);
                folderToPush.node_type =  'folder';
                folderToPush.folder_module_id = fm.id;
                modules.push(folderToPush);
              }
            break;

            default:
            break;
          }
        });

        if (sortingField) {
          if (sortingField.includes(".")) {
            let arraySortingField = sortingField.split(".");
            let sortingFieldName = arraySortingField[arraySortingField.length - 1];
            modules = modules.map(st => {
              let value = _.get(st, sortingField, null);
              st[sortingFieldName] = value;
              return st;
            });
            modules = _.orderBy(modules, [sortingFieldName], ['asc']);
          } else {
            modules = _.orderBy(modules, [sortingField], ['asc']);
          }
        }
        return modules;
      }
    }
  },


  getSubfoldersIdsRecursively: (folders, parent, results = []) => {
    let foundFolders = folders.filter(fl => fl.parent_category === parent).map(fl => fl.id);
    results = results.concat(foundFolders);
    if (foundFolders.length > 0) {
      for (let i = 0; i < foundFolders.length; i++) {
        results = self.getSubfoldersIdsRecursively(folders, foundFolders[i], results);
      }
      return results;
    } else {
      return results;
    }
  },

  getRandomStr: () => {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  },

  appendPrependQuillOps: (ops, append, prepend) => {
    if (ops[0] && ops[0].attributes) {
      append.attributes = ops[0].attributes;
      prepend.attributes = ops[0].attributes;
    }

    ops.unshift(prepend);
    ops.push({});
    ops[ops.length - 2] = ops[ops.length - 1];
    ops[ops.length - 1] = append;

    return ops;
  },

  parseTextStyling: (style) => {
    if (!style) {
      return null;
    }
   
    const fontFamily = _.get(style, 'font', _.get(style, 'default.font', null));
    const color = _.get(style, 'fontColor', _.get(style, 'default.fontColor', null));
    const fontSize = _.get(style, 'fontSize', _.get(style, 'default.fontSize', null));
    const fontStyle = _.get(style, 'fontStyle', _.get(style, 'default.fontStyle', null));
    const fontWeight = _.get(style, 'fontWeight', _.get(style, 'default.fontWeight', null));
    const textAlign = _.get(style, 'justification', _.get(style, 'default.justification', null));
    const lineHeight = _.get(style, 'height', _.get(style, 'default.height', null));
    const visibility = _.get(style, 'visible', _.get(style, 'default.visible', null));
   
    return {
      fontFamily,
      color,
      fontSize: `${fontSize}vh`,
      fontStyle,
      fontWeight,
      textAlign,
      lineHeight: `${lineHeight}vh`,
      visibility: visibility ? "visible" : "hidden"
    };
  }
}


// WEBPACK FOOTER //
// ./src/utils/shared.js